module.exports = __webpack_public_path__ + "img/teac.6eccbe9f.png";